import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Button, Form, Input, Modal, Select } from "antd";
import PhoneInput from "react-phone-input-2";

import { buildBookingRef } from "../../utils/helpers";
import { cellPhoneValidator, validateMessages } from "../../utils/validation";
import { update } from "../../store/actions/booking-actions";
import classes from "./EditBookingModal.module.scss";

export default function EditBookingModal({
  open,
  onClose,
  booking,
  onBookingEdited,
}) {
  const isLoading = useSelector((state) => state.bookings.isLoading);
  const [error, setError] = useState();

  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const deliveryTypeOptions = useSelector(
    (state) => state.options.deliveryTypeOptions
  );
  const driverOptions = useSelector((state) => state.drivers.options);
  const vehicleOptions = useSelector((state) => state.vehicles.options);

  useEffect(() => {
    if (booking?.id) {
      const newObject = {
        driverId: booking.driver.id,
        vehicleId: booking.vehicle.id,
        deliveryType: booking.deliveryType,
        receiverName: booking.receiverName,
        receiverPhone: booking.receiverPhone.substring(1),
      };
      form.setFieldsValue(newObject);
    }
  }, [booking, form]);

  useEffect(() => {
    if (!open) setError("");
  }, [open]);

  const handleSubmit = async (values) => {
    const finalValues = {
      ...values,
      receiverPhone: `+${values.receiverPhone}`,
    };
    try {
      await dispatch(update(booking.id, finalValues));
      onBookingEdited();
    } catch (error) {
      if (error.status === 500) {
        setError("Internal Server Error");
      } else setError(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <Modal
      title={`Booking - ${booking?.id && buildBookingRef(booking.id)}`}
      open={open}
      className={classes.modal}
      footer={null}
      onCancel={onClose}
      width={"50vw"}
      styles={{
        body: { minHeight: "400px", paddingRight: 24, paddingTop: 24 },
        header: { background: "#d2dbdf", marginBottom: 32 },
        content: { background: "#d2dbdf" },
      }}
      centered
    >
      {error && <Alert message={error} type="error" />}
      <Form
        form={form}
        onFinish={handleSubmit}
        labelCol={{ flex: "200px" }}
        labelAlign="left"
        autoComplete="off"
        validateMessages={validateMessages}
      >
        <Form.Item
          name="driverId"
          label="Driver"
          rules={[{ required: "true" }]}
        >
          <Select placeholder="Select driver" options={driverOptions} />
        </Form.Item>

        <Form.Item
          name="vehicleId"
          label="Vehicle"
          rules={[{ required: "true" }]}
        >
          <Select placeholder="Select vehicle" options={vehicleOptions} />
        </Form.Item>

        <Form.Item
          name="deliveryType"
          label="Delivery Type"
          rules={[{ required: "true" }]}
        >
          <Select
            placeholder="Select Delivery Type"
            options={deliveryTypeOptions}
          />
        </Form.Item>

        <Form.Item
          name="receiverName"
          label="Receiver Name"
          rules={[{ required: "true", max: 20 }]}
        >
          <Input placeholder="Enter receiver name" />
        </Form.Item>

        <Form.Item
          name="receiverPhone"
          label="Receiver Phone Number"
          rules={[
            {
              required: "true",
              validator: cellPhoneValidator("Receiver Phone Number"),
            },
          ]}
        >
          <PhoneInput
            country={"az"}
            enableSearch={true}
            placeholder="+994 (50) 000-00-00"
          />
        </Form.Item>
        <div className={classes.customFooter}>
          <Form.Item>
            <Button
              className={classes.submitButton}
              disabled={isLoading}
              type="primary"
              htmlType="submit"
              size="large"
            >
              {isLoading ? "Saving..." : "Save"}
            </Button>
          </Form.Item>
          <Button size="large" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Form>
    </Modal>
  );
}
